<template>
  <Modal
    class="tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]"
    :visible="showRef"
    border-radius="6px"
    height="268px"
    :style-modal="'!tw-overflow-hidden'"
    @close="handleCloseModal"
  >
    <ModalHeader
      :class="`modal-header`"
      :title="
        getComponentUiText('app-assess-assessment-template-title-modal-1')
      "
      @close="handleCloseModal"
    />
    <div
      class="tw-bg-[#fff] tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[28px] tw-self-stretch tw-p-[40px]"
    >
      <div
        class="tw-flex tw-justify-between tw-w-[100%] tw-flex-col md:tw-flex-row tw-gap-[20px] md:tw-gap-0"
      >
        <div
          class="tw-flex tw-text-[18px] tw-font-semibold tw-text-[#211f58] tw-items-center"
        >
          {{
            getComponentUiText(
              "app-assess-assessment-modal-manage-template-title-template-1",
            )
          }}
        </div>
        <div
          class="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-5 tw-items-start"
        >
          <BaseSearchbox
            :class="[
              'md:tw-w-[300px] tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#fcfcfd] tw-p-[15px] search-box',
            ]"
            input-style="tw-bg-[#fcfcfd]"
            :model-value="searchValue"
            :placeholder="getComponentUiText('app-header-search-prompt-1')"
            @update:model-value="($event) => updateSearchValue($event)"
            @on:focus="() => {}"
            @on:blur="() => {}"
            @keyup.enter="() => {}"
          />
          <div class="tw-flex">
            <div @click="handleShowBulkAction">
              <ButtonBulkActions
                :active="selectedTemplate.length >= 1"
                :show-more-actions="
                  isShowMoreActions && selectedTemplate.length >= 1
                "
                :button-class="`!tw-border !tw-border-solid !tw-border-[#EFF0F1]`"
                button-class-hover="!tw-bg-[#fcfcfd]"
                :id-popover="'popover-manage-template-modal'"
                :show-acction-click="true"
                :is-margin-right="false"
                :selected-number="selectedTemplate.length"
              >
                <CustomDropDownItem
                  :style="!isHaveDeleteBulkAction ? 'disabled' : 'danger'"
                  :id-text="'app-assess-assessment-manage-template-modal-delete-template-title-1'"
                  :style-text="
                    !isHaveDeleteBulkAction ? '!tw-cursor-not-allowed' : ''
                  "
                  @click="() => _showModalRemoveTemplates(selectedTemplate)"
                />
              </ButtonBulkActions>
            </div>
            <div
              id="popover-target-1"
              class="toggle-switch-view tw-ml-[20px] tw-relative"
              :class="` !tw-border !tw-border-solid !tw-border-[#EFF0F1]
                ${
                  isCheckToggleOptionSetting.value
                    ? ' setting-option-selected'
                    : '!tw-bg-[#fcfcfd]'
                }
              `"
              @click="openDisplayOption"
              @mouseover="isCogHover = true"
              @mouseout="isCogHover = false"
            >
              <label class="tw-cursor-pointer">
                <span class="tw-p-[14px]">
                  <img
                    v-show="isCheckToggleOptionSetting.value"
                    src="@/assets/img/setting_option_selected.svg"
                    alt=""
                  />
                  <img
                    v-show="
                      !isCheckToggleOptionSetting.value &&
                      !isShowToolTip &&
                      !isCogHover
                    "
                    src="@/assets/img/setting_option.svg"
                    alt=""
                  />
                  <img
                    v-show="
                      !isCheckToggleOptionSetting.value &&
                      (isShowToolTip || isCogHover)
                    "
                    src="@/assets/img/setting_option_active.svg"
                    alt=""
                  />
                </span>
              </label>
            </div>
            <b-popover
              ref="popover_option"
              target="popover-target-1"
              placement="bottom-end"
              click="true"
              :offset="15"
              :custom-class="`custom-actions-popover assessment-display-options`"
              class="tw-absolute"
              @show="isShowToolTip = true"
              @hidden="isShowToolTip = false"
            >
              <AssessmentDisplayOptions :list-option="listOption" />
            </b-popover>
          </div>
        </div>
      </div>
      <div
        :class="`tw-w-full contain-table tw-rounded-md tw-overflow-y-auto
          'tw-flex tw-items-center'
        `"
      >
        <ManageTemplateTable
          :table-data="orgDomainsFiltered"
          :table-fields="tableFields"
          :empty-text="
            getComponentUiText(
              'app-assess-assessment-modal-manage-template-empty-1',
            )
          "
          @delete:assessment="_showModalRemoveTemplate"
          @create:assessment="handleCreateAssessment"
          @select:row="handleSelectTemplate"
        />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { onMounted, Ref, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { countLeafNodes, getComponentUiText } from "@/utils/utilities";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import ManageTemplateTable from "./manageTemplateTable.vue";
import {
  localStorageKey,
  MODAL_NAME,
  successStatusCodes,
} from "@/utils/constants";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import { deleteChecklistTemplate } from "@/services/assessment";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import store from "@/store";
import { computed } from "vue";
import { createChecklistToItem } from "@/services/assessment";
import router from "@/router";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import AssessmentDisplayOptions from "./assessmentDisplayOptions.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import { getOrgDetails } from "@/services/org";
import { Org } from "@/services/apiRoutes/routes";

const isCloseModal = ref(false);
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
});
let nameCode = ref("");
let showRef = ref(props.show);
let notInfoVisible = ref(true);
const isShowMoreActions = ref(false);
const searchValue: Ref<string> = ref("");
const isShowToolTip: Ref<boolean> = ref(false);
const popover_option: any = ref(null);
const isCogHover: Ref<boolean> = ref(false);
const listTemplate = computed(() => store.state.Assessment.listTemplate);
const currentOrg = computed(() => store.state.Org.currentOrg);
const hideSystemOption = ref(false);
const selectedTemplate: Ref<any[]> = ref([]);
const isHaveDeleteBulkAction = computed(() => {
  return selectedTemplate.value.some((item) => item?.templateOrgId !== null);
});

const isCheckToggleOptionSetting = computed(() => {
  return hideSystemOption;
});
const listOption = computed(() => [
  {
    title: getComponentUiText(
      "app-assess-assessment-manage-template-modal-hide-system-template-title-1",
    ),
    value: hideSystemOption.value,
    action: () => {
      hideSystemOption.value = !hideSystemOption.value;
      localStorage.setItem(
        localStorageKey.hideSystemTemplate,
        hideSystemOption.value.toString(),
      );
    },
  },
]);

const handleSelectTemplate = (selected: any) => {
  selectedTemplate.value = selected;
};
const openDisplayOption = () => {
  setTimeout(() => {
    popover_option?.value?.$emit("show");
  }, 500);
};

const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
};

watch(
  () => selectedTemplate.value,
  (value) => {
    if (value.length < 1) {
      isShowMoreActions.value = false;
    }
  },
);

const orgDomainsFiltered = computed(() => {
  const data = listTemplate.value.map((item) => {
    let type = "";

    if (item.templateOrgId) {
      getNameCode(item.templateOrgId);
    }
    switch (true) {
      case item.templateOrgId === null:
        type = getComponentUiText(
          "app-assess-assessment-manage-template-modal-type-system-1",
        );
        break;
      case item.templateOrgId === currentOrg.value.id:
        type = getComponentUiText(
          "app-assess-assessment-manage-template-modal-type-org-1",
        );
        break;
      case Boolean(item.templateOrgId):
        type = nameCode.value.toUpperCase();
        break;
      default:
        type = "";
    }

    return {
      id: item.templateId,
      name: item.templateName,
      templateType: type,
      version: item.templateVersion,
      ...item,
    };
  });
  const search = searchValue.value.toLocaleLowerCase();
  const dataSearch = data.filter((item) => {
    return (
      (item.name.toLowerCase().includes(search) ||
        item.templateType.toLowerCase().includes(search) ||
        item.templateDescription.toLowerCase().includes(search) ||
        item.questionNumber?.toString().includes(search)) &&
      (hideSystemOption.value ? item.templateOrgId !== null : true)
    );
  });
  return dataSearch;
});

const getNameCode = async (orgId) => {
  try {
    const res = await getOrgDetails(orgId);
    nameCode.value = res.data.data.nameCode;
  } catch (error) {
    showErrorAPI(error, Org.getOrg);
  }
};

const tableFields = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "name",
    headerClass:
      "tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    valueClass: "tw-w-[200px] !tw-pr-[16px]",
    font13: true,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-create-update-description-1",
    ),
    value: "templateDescription",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase  tw-w-[200px]",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[12px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    font13: true,
    valueClass: "tw-w-[300px] !tw-text-[#231F20] !tw-text-[12px] !tw-pr-[16px]",
    textAlign: false,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-manage-template-column-template-type-1",
    ),
    value: "templateType",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-flex tw-items-center tw-justify-center",
    render: (value: string) =>
      `<span class="tw-text-[#212529] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    valueClass: " !tw-pr-[16px]",
    font13: true,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-create-update-questions-1",
    ),
    value: "itemCount",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    font13: true,
    valueClass: "tw-w-[20px] !tw-pr-[16px]",
    textAlign: true,
  },
  {
    text: "",
    value: "",
    headerClass: "",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "!tw-pr-[16px]",
  },
  {
    text: "",
    value: "expland",
    headerClass: "",
    valueClass: "!tw-w-[12px]",
  },
];

const showModalRemoveTemplate = (data: {
  title: string;
  description: string;
  buttonText?: string;
  slotCustom?: any;
  onUpdate: () => void;
  buttonRed?: boolean;
  hiddenHelp?: boolean;
  list?: string[];
}) => {
  isCloseModal.value = true;
  const emitData = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: data.title ? getComponentUiText(data.title) : "",
      description: data.description ? getComponentUiText(data.description) : "",
      buttonText: data.buttonText ? getComponentUiText(data.buttonText) : "",
      buttonRed: !!data.buttonRed,
      modalContainerClass: "tw-z-[1071]",
      slotCustom: data.slotCustom,
      list: data.list ?? [],
      hiddenHelp: data.hiddenHelp,
      updateDataFunction: data.onUpdate,
    },
    events: {
      "update:data": () => data.onUpdate(),
      "update:close": () => (isCloseModal.value = false),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const _showModalRemoveTemplate = (item: any) => {
  showModalRemoveTemplate({
    title: "app-assess-assessment-modal-delete-template-title-1",
    description: "app-assess-assessment-modal-delete-template-content-1",
    buttonText: "app-assess-assessment-modal-delete-template-title-1",
    buttonRed: true,
    hiddenHelp: false,
    onUpdate: async () => await handleDeleteTemplate([item]),
  });
};

const _showModalRemoveTemplates = (items: any[]) => {
  if (!isHaveDeleteBulkAction.value) return;
  showModalRemoveTemplate({
    title:
      "app-assess-assessment-manage-template-modal-delete-template-title-1",
    description: "app-assess-assessment-modal-delete-templates-content-1",
    buttonText: "app-assess-assessment-modal-delete-template-title-1",
    buttonRed: true,
    hiddenHelp: false,
    list: items.map((item) => item.name),
    onUpdate: async () => await handleDeleteTemplate(items),
  });
};

const handleDeleteTemplate = async (items: any[]) => {
  try {
    isCloseModal.value = false;
    const templateIds = items.map((item) => item.id);
    const res = await deleteChecklistTemplate({
      templateIds: templateIds,
    });
    if (res.status === successStatusCodes.OK) {
      store.commit("Assessment/UPDATE_DELETE_CHECKLIST_TEMPLATE", templateIds);
      if (items.length > 1) {
        showSuccessToast(
          getComponentUiText(
            "app-api-assessment-delete-templates-success-1",
            false,
            {
              totalTemplate: items.length.toString(),
            },
          ),
        );
      } else {
        showSuccessToast(
          getComponentUiText(
            "app-api-assessment-delete-template-success-1",
            false,
            { templateName: items[0].name },
          ),
        );
      }
    }
  } catch (error) {
    showErrorAPI(error, Checklist.deleteChecklistTemplate);
  }
};

const handleCreateAssessment = async (item: any) => {
  try {
    const data = {
      templateId: item.id,
      checklistName: `Created from templateId ${item.id}`,
      checklistDescription: "",
      checklistNotes: "",
    };
    const res = await createChecklistToItem(data);
    if (
      res.data?.data &&
      res.status === successStatusCodes.OK &&
      typeof res.data.data === "object" &&
      "checklistId" in res.data.data
    ) {
      const checklistId = res.data.data.checklistId as number;
      const query = { checklistId: checklistId };
      router.push({ path: "/assess/input", query });
    }
  } catch (error) {
    showErrorAPI(error, Checklist.createChecklistToItem);
  }
};

onMounted(() => {
  if (localStorage.getItem(localStorageKey.hideSystemTemplate) === "true") {
    hideSystemOption.value = true;
  }
});

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    isCloseModal.value = false;
    if (value) {
      notInfoVisible.value = true;
      store.dispatch("Assessment/getTemplate");
    }
  },
);

const emit = defineEmits(["update:show", "resetModalHistory"]);

const handleCloseModal = () => {
  if (isCloseModal.value == false) {
    selectedTemplate.value = [];
    searchValue.value = "";
    showRef.value = false;
    emit("update:show", showRef.value);
  }
};

const updateSearchValue = (value: string) => {
  searchValue.value = value;
};
</script>

<style lang="scss" scoped>
.contain-table {
  max-height: calc(100vh - 375px);
}
@media screen and (max-width: 768px) {
  .contain-table {
    max-height: calc(100vh - 500px);
  }
}
.toggle-switch-view {
  border-radius: 6px;
  background: var(--ui-white, #fff);
  backdrop-filter: blur(6px);
  align-items: center;
  display: inline-flex;

  label {
    margin-bottom: 0;
  }
  .label {
    display: flex;
    cursor: pointer;
    padding: 10px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    color: var(--ui-light-grey, #b7b7b7);
    letter-spacing: 1px;
    border-radius: 6px;
    min-width: 16px;
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    &:checked + .label {
      background: var(--brand-navy, #211f58);
      color: #fff;
    }
  }
  &.setting-option-selected {
    background: var(--brand-navy, #211f58);
  }
}

.search-box {
  // box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

.main {
  border: 1px solid #eff0f1;
  background: rgba(239, 240, 241, 0.5);
  transition: all 0.3s ease-in-out;
}

.templateAssessmentWrapper {
  background: #fcfcfd;
  transition: all 0.3s ease-in-out;
  border: 1px solid #eff0f1;
  background: #ffffff;
  max-height: 400px;
}

.templateAssessmentWrapper .templateDropdownItem {
  transition: all 0.3s ease-in-out;
  color: #231f20;
  font-size: 13px;
  font-weight: 400;
}

.templateAssessmentWrapper .templateDropdownItem:hover {
  background: #f2f8ff;
}

.templateAssessmentWrapper .templateDropdownItem:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.close {
  height: 0;
  padding: 0;
  overflow: hidden;
  filter: blur(1px);
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
